<div class="popover-container">
  <div class="overlay">
    <vm-screen-overlay *ngIf="showLoginNav" [disableScroll]="true" (click)="toggleLoginNav()"></vm-screen-overlay>
  </div>
  <div class="vm-container">
    <div *ngIf="loginContent$ | async as pageContent" class="login-popover">
      <div class="popover-body" [ngClass]="{ 'section-overlay--visible': showLoginNav }" *ngIf="showLoginNav" #popOver>
        <div class="popover-arrow"></div>
        <div class="login-wrapper">
          <div class="vm-container popover-content">
            <ng-container *ngIf="!isAuthenticated">
              <div class="vm-row">
                <div class="xs-12">
                  <div class="login-title">
                    <a class="text-button sign-in" href="javascript:void(0)" (click)="login()"
                      ><i class="fa fa-chevron-right lighter-grey"></i>{{ pageContent.buttons[0].label }}
                    </a>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!isAuthenticated">
              <div class="vm-row">
                <div class="xs-12">
                  <div class="login-title">
                    <a
                      data-cy="sign-in-to-my-mobile"
                      class="text-button sign-in-mobile"
                      href="{{ pageContent.buttons[1].url }}"
                      ><i class="fa fa-chevron-right lighter-grey"></i>{{ pageContent.buttons[1].label }}
                    </a>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!isAuthenticated">
              <div class="vm-row">
                <div class="xs-12">
                  <div class="login-title">
                    <a data-cy="no-account-sign-up-btn" class="text-button sign-up" href="{{ signUpUrl }}"
                      ><i class="fa fa-chevron-right lighter-grey"></i>{{ pageContent.buttons[2].label }}
                    </a>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="isAuthenticated">
              <div class="vm-row">
                <div class="xs-12">
                  <div class="login-title">
                    <i class="fa fa-chevron-right lighter-grey"></i>
                    <a class="text-button sign-out" href="javascript:void(0)" (click)="logout()">
                      {{ pageContent.buttons[3].label }}
                    </a>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
